import AudibleFilter from '@customer/side-panels/filter-panel/filters/AudibleFilter';
import { FilterConfig, FilterElement, FiltersList } from './types';
import AssetGroupsFilter from '@customer/side-panels/filter-panel/filters/AssetGroupsFilter';
import AssetGroupsRoFilter from '@customer/side-panels/filter-panel/filters/AssetGroupsRoFilter';
import ConfigGroupsFilter from '@customer/side-panels/filter-panel/filters/ConfigGroupsFilter';
import DeviceTypesFilter from '@customer/side-panels/filter-panel/filters/DeviceTypesFilter';
import FaultCategoriesFilter from '@customer/side-panels/filter-panel/filters/FaultCategoriesFilter';
import FaultLevelsFilter from '@customer/side-panels/filter-panel/filters/FaultLevelsFilter';
import FaultsFilter from '@customer/side-panels/filter-panel/filters/FaultsFilter';
import FaultStatusFilter from '@customer/side-panels/filter-panel/filters/FaultStatusFilter';
import GeofenceInteractionTypesFilter from '@customer/side-panels/filter-panel/filters/GeofenceInteractionTypesFilter';
import IgnitionMinimumFilter from '@customer/side-panels/filter-panel/filters/IgnitionMinimumFilter';
import MaxDistanceFilter from '@customer/side-panels/filter-panel/filters/MaxDistanceFilter';
import MinDurationFilter from '@customer/side-panels/filter-panel/filters/MinDurationFilter';
import MinSpeedLoFilter from '@customer/side-panels/filter-panel/filters/MinSpeedLoFilter';
import MinSpeedRoFilter from '@customer/side-panels/filter-panel/filters/MinSpeedRoFilter';
import SoftwareStatusFilter from '@customer/side-panels/filter-panel/filters/SoftwareStatusFilter';
import VehicleInteractionTypesFilter from '@customer/side-panels/filter-panel/filters/VehicleInteractionTypesFilter';
import MinTravelledDistanceFilter from '@customer/side-panels/filter-panel/filters/MinTravelledDistanceFilter';
import MaxSpeedLoFilter from '@customer/side-panels/filter-panel/filters/MaxSpeedLoFilter';
import TimeOfDayEndFilter from '@customer/side-panels/filter-panel/filters/TimeOfDayEndFilter';
import TimeOfDayStartFilter from '@customer/side-panels/filter-panel/filters/TimeOfDayStartFilter';
import ObjectTypesFilter from '@customer/side-panels/filter-panel/filters/ObjectTypesFilter';
import ObjectTypesRoFilter from '@customer/side-panels/filter-panel/filters/ObjectTypesRoFilter';
import GeofenceAreasFilter from '@customer/side-panels/filter-panel/filters/GeofenceAreasFilter';
import GeofenceTypesFilter from '@customer/side-panels/filter-panel/filters/GeofenceTypesFilter';
import TechLibraryDocumentTypesFilter from '@customer/side-panels/filter-panel/filters/TechLibraryDocumentTypesFilter';
import TechLibraryProductFamiliesFilter from '@customer/side-panels/filter-panel/filters/TechLibraryProductFamiliesFilter';
import TechLibraryProductsFilter from '@customer/side-panels/filter-panel/filters/TechLibraryProductsFilter';
import PartnerResourceTypesFilter from '@customer/side-panels/filter-panel/filters/PartnerResourceTypesFilter';
import PartnerResourceFileTypesFilter from '@customer/side-panels/filter-panel/filters/PartnerResourceFileTypesFilter';
import GpsFixFilter from '@customer/side-panels/filter-panel/filters/GpsFixFilter';
import InvestigationTypesFilter from '@customer/side-panels/filter-panel/filters/InvestigationTypesFilter';
import InvestigationStatusesFilter from '@customer/side-panels/filter-panel/filters/InvestigationStatusesFilter';

export const FILTERS_CONFIG: FilterConfig[] = [
  {
    name: 'audible',
    FilterComponent: AudibleFilter,
    elementType: FilterElement.VdsDropdown,
  },
  {
    name: 'assetGroups',
    FilterComponent: AssetGroupsFilter,
    elementType: FilterElement.VdsDropdownMultiselect,
  },
  {
    name: 'assetGroupsRo',
    FilterComponent: AssetGroupsRoFilter,
    elementType: FilterElement.VdsDropdownMultiselect,
  },
  {
    name: 'configGroups',
    FilterComponent: ConfigGroupsFilter,
    elementType: FilterElement.VdsDropdownMultiselect,
  },
  {
    name: 'deviceTypes',
    FilterComponent: DeviceTypesFilter,
    elementType: FilterElement.VdsDropdownMultiselect,
  },
  {
    name: 'faultCategories',
    FilterComponent: FaultCategoriesFilter,
    elementType: FilterElement.VdsDropdownMultiselect,
  },
  {
    name: 'faultLevels',
    FilterComponent: FaultLevelsFilter,
    elementType: FilterElement.VdsDropdownMultiselect,
  },
  {
    name: 'faults',
    FilterComponent: FaultsFilter,
    elementType: FilterElement.VdsDropdownMultiselect,
  },
  {
    name: 'faultStatus',
    FilterComponent: FaultStatusFilter,
    elementType: FilterElement.VdsDropdown,
  },
  {
    name: 'geofenceAreas',
    FilterComponent: GeofenceAreasFilter,
    elementType: FilterElement.VdsDropdownMultiselect,
  },
  {
    name: 'geofenceInteractionTypes',
    FilterComponent: GeofenceInteractionTypesFilter,
    elementType: FilterElement.VdsDropdownMultiselect,
  },
  {
    name: 'geofenceTypes',
    FilterComponent: GeofenceTypesFilter,
    elementType: FilterElement.VdsDropdownMultiselect,
  },
  {
    name: 'gpsFix',
    FilterComponent: GpsFixFilter,
    elementType: FilterElement.VdsDropdown,
  },
  {
    name: 'ignitionMinimum',
    FilterComponent: IgnitionMinimumFilter,
    elementType: FilterElement.VdsDropdown,
  },
  {
    name: 'investigationTypes',
    FilterComponent: InvestigationTypesFilter,
    elementType: FilterElement.VdsDropdownMultiselect,
  },
  {
    name: 'investigationStatuses',
    FilterComponent: InvestigationStatusesFilter,
    elementType: FilterElement.VdsDropdownMultiselect,
  },
  {
    name: 'maxDistance',
    FilterComponent: MaxDistanceFilter,
    elementType: FilterElement.VdsInput,
  },
  {
    name: 'maxSpeedLo',
    FilterComponent: MaxSpeedLoFilter,
    elementType: FilterElement.VdsInput,
  },
  {
    name: 'minDuration',
    FilterComponent: MinDurationFilter,
    elementType: FilterElement.VdsInput,
  },
  {
    name: 'minSpeedLo',
    FilterComponent: MinSpeedLoFilter,
    elementType: FilterElement.VdsInput,
  },
  {
    name: 'minSpeedRo',
    FilterComponent: MinSpeedRoFilter,
    elementType: FilterElement.VdsInput,
  },
  {
    name: 'minTravelledDistance',
    FilterComponent: MinTravelledDistanceFilter,
    elementType: FilterElement.VdsInput,
  },
  {
    name: 'objectTypes',
    FilterComponent: ObjectTypesFilter,
    elementType: FilterElement.VdsDropdownMultiselect,
  },
  {
    name: 'objectTypesRo',
    FilterComponent: ObjectTypesRoFilter,
    elementType: FilterElement.VdsDropdownMultiselect,
  },
  {
    name: 'partnerResourceTypes',
    FilterComponent: PartnerResourceTypesFilter,
    elementType: FilterElement.VdsDropdownMultiselect,
  },
  {
    name: 'partnerResourceFileTypes',
    FilterComponent: PartnerResourceFileTypesFilter,
    elementType: FilterElement.VdsDropdownMultiselect,
  },
  {
    name: 'softwareStatus',
    FilterComponent: SoftwareStatusFilter,
    elementType: FilterElement.VdsDropdown,
  },
  {
    name: 'vehicleInteractionTypes',
    FilterComponent: VehicleInteractionTypesFilter,
    elementType: FilterElement.VdsDropdownMultiselect,
  },
  {
    name: 'techLibDocumentTypes',
    FilterComponent: TechLibraryDocumentTypesFilter,
    elementType: FilterElement.VdsDropdownMultiselect,
  },
  {
    name: 'techLibProducts',
    FilterComponent: TechLibraryProductsFilter,
    elementType: FilterElement.VdsDropdownMultiselect,
  },
  {
    name: 'techLibProductFamilies',
    FilterComponent: TechLibraryProductFamiliesFilter,
    elementType: FilterElement.VdsDropdownMultiselect,
  },
  {
    name: 'timeOfDayEnd',
    FilterComponent: TimeOfDayEndFilter,
    elementType: FilterElement.VdsDropdown,
  },
  {
    name: 'timeOfDayStart',
    FilterComponent: TimeOfDayStartFilter,
    elementType: FilterElement.VdsDropdown,
  },
];

/* Filter Groups */

export const ASSET_LIST_FILTERS: FiltersList = [
  'assetGroups',
  'deviceTypes',
  'objectTypes',
  'configGroups',
  'softwareStatus',
];

export const ASSET_SELF_TEST_FILTERS: FiltersList = [
  'faultLevels',
  'faultCategories',
  'faults',
  'faultStatus',
];

export const ASSET_VI_FILTERS: FiltersList = [
  'assetGroupsRo',
  'vehicleInteractionTypes',
  { name: 'audible', fullWidth: false },
  { name: 'gpsFix', fullWidth: false },
  { name: 'minSpeedLo', fullWidth: false },
  { name: 'minSpeedRo', fullWidth: false },
  { name: 'maxDistance', fullWidth: false },
  { name: 'minDuration', fullWidth: false },
];

export const ASSET_GI_FILTERS: FiltersList = [
  { name: 'geofenceInteractionTypes', fullWidth: true },
  { name: 'geofenceAreas', fullWidth: false },
  { name: 'geofenceTypes', fullWidth: false },
  { name: 'audible', fullWidth: false },
  { name: 'gpsFix', fullWidth: false },
  { name: 'minSpeedLo', fullWidth: false },
  { name: 'maxSpeedLo', fullWidth: false },
  { name: 'minTravelledDistance', fullWidth: false },
  { name: 'minDuration', fullWidth: false },
  { name: 'timeOfDayStart', fullWidth: false },
  { name: 'timeOfDayEnd', fullWidth: false },
];

export const HEALTH_SUMMARY_FILTERS: FiltersList = [
  'assetGroups',
  'ignitionMinimum',
  'deviceTypes',
  'softwareStatus',
];

export const HEALTH_SELF_TEST_FILTERS: FiltersList = [
  'faultCategories',
  'faults',
  'assetGroups',
  'deviceTypes',
];

export const HEALTH_SOFTWARE_STATUS_FILTERS: FiltersList = [
  'assetGroups',
  'deviceTypes',
  'configGroups',
];

export const HEALTH_REPORTING_FILTERS: FiltersList = [...HEALTH_SOFTWARE_STATUS_FILTERS];

export const INVESTIGATIONS_FILTERS: FiltersList = ['investigationTypes', 'investigationStatuses'];

export const PERFORMANCE_VI_FILTERS: FiltersList = [
  { name: 'assetGroups', labelTransKey: 'AssetGroupLO', fullWidth: false },
  { name: 'deviceTypes', labelTransKey: 'DeviceTypeLO', fullWidth: false },
  { name: 'objectTypes', labelTransKey: 'ObjectTypeLO' },
  'assetGroupsRo',
  { name: 'objectTypesRo', labelTransKey: 'ObjectTypeRO' },
  'vehicleInteractionTypes',
  { name: 'audible', fullWidth: false },
  { name: 'gpsFix', fullWidth: false },
  { name: 'minSpeedLo', fullWidth: false },
  { name: 'minSpeedRo', fullWidth: false },
  { name: 'maxDistance', fullWidth: false },
  { name: 'minDuration', fullWidth: false },
];

export const PERFORMANCE_GI_FILTERS: FiltersList = [
  { name: 'assetGroups', fullWidth: false },
  { name: 'objectTypes', fullWidth: false },
  { name: 'deviceTypes', fullWidth: false },
  { name: 'geofenceInteractionTypes', fullWidth: false },
  { name: 'geofenceAreas', fullWidth: false },
  { name: 'geofenceTypes', fullWidth: false },
  { name: 'audible', fullWidth: false },
  { name: 'gpsFix', fullWidth: false },
  { name: 'minSpeedLo', fullWidth: false },
  { name: 'maxSpeedLo', fullWidth: false },
  { name: 'minTravelledDistance', fullWidth: false },
  { name: 'minDuration', fullWidth: false },
  { name: 'timeOfDayStart', fullWidth: false },
  { name: 'timeOfDayEnd', fullWidth: false },
];

export const TECH_LIBRARY_FILTERS: FiltersList = [
  'techLibDocumentTypes',
  'techLibProductFamilies',
  'techLibProducts',
];

export const PARTNER_RESOURCES_FILTERS: FiltersList = [
  'partnerResourceTypes',
  'partnerResourceFileTypes',
];
